import { render, staticRenderFns } from "./ImageMetadataModal.vue?vue&type=template&id=cf1472be&scoped=true&"
import script from "./ImageMetadataModal.vue?vue&type=script&lang=js&"
export * from "./ImageMetadataModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageMetadataModal.vue?vue&type=style&index=0&id=cf1472be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1472be",
  null
  
)

export default component.exports